import { inject, Injectable } from '@angular/core';
import { ILoggerNoiseHistogram } from '@app/api/interfaces/chart-data/logger-noise-histogram';
import { DayJSDateFormat } from '@app/core/enums/date-format.enum';
import { DayjsLocaleService } from '@app/core/i18n/services/dayjs-locale.service';
import { CsvColumnConfig, CsvExportService } from '@app/core/services/csv-export/csv-export.service';
import { CsvExportFormattingService } from '@app/core/services/csv-export/csv-export-formatting.service';
import { _, TranslateService } from '@ngx-translate/core';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

@Injectable()
export class FpLoggerNoiseHistogramExportService {
  protected readonly csvExportService = inject(CsvExportService);
  protected readonly csvFormat = inject(CsvExportFormattingService);
  protected readonly dayjsLocale = inject(DayjsLocaleService);
  private readonly translate = inject(TranslateService);

  private getCsvColumnConfig(): CsvColumnConfig<ILoggerNoiseHistogram>[] {
    return [
      {
        header: this.translate.instant(_('@@chart-export-csv-header-noise-decibel')),
        value: row => this.csvFormat.formatNumber(row.noiseDecibel),
      },
      {
        header: this.translate.instant(_('@@shared-count')),
        value: row => this.csvFormat.formatNumber(row.count),
      },
    ];
  }

  public exportCsv(popupMainData: ILdLogger, data: ILoggerNoiseHistogram[]): void {
    const serialNo = popupMainData.deployment.serialNo;
    const date = popupMainData.measurement?.measStartTime;
    const formattedDate = this.dayjsLocale.dayjs(date).format(DayJSDateFormat.YYYYMMDD_HHmm);

    this.csvExportService.downloadCsv(`Histogram_${serialNo}_${formattedDate}.csv`, data, this.getCsvColumnConfig());
  }
}
